import BaseFilterModel from "./BaseFilterModel";
import { computed } from "mobx";
import isFunction from "lodash/isFunction";
import isNull from "lodash/isNull";
import toLower from "lodash/toLower";
import isUndefined from "lodash/isUndefined";

class SelectFilterModel extends BaseFilterModel {
    get key() {
        return this.definition.name || this.columnName || "select";
    }

    @computed
    get func() {
        return rowData => {
            const rowValue = rowData.get(this.columnName);
            if (isFunction(this.definition.compareFunction)) {
                return this.definition.compareFunction(rowValue, this.value);
            } else {
                return !isNull(rowValue) && toLower(rowValue.toString()) === toLower(this.value.toString());
            }
        };
    }

    get defaultValue() {
        return isUndefined(super.defaultValue) ? "" : super.defaultValue;
    }
}

export default SelectFilterModel;
